import { Link, MobilePage } from '@tbitop/mobile-app';
import { useQueryParamState } from '@tbitop/routing';
import type { Sorting } from '@tbitop/ui';
import { Filtering } from '@tbitop/ui';
import { useState } from 'react';
import { KampagnenSortierung, Sortierrichtung } from '../infrastructure/graphql/__generated__/globalTypes';


import { House } from 'phosphor-react';
import { toSortierkriterium, toSortierrichtung } from '../core/application/sorting';
import { useKampagnenSeitenweiseQuery } from '../infrastructure/graphql/KampagnenSeitenweiseQuery';
import { KampagnenListPagination } from '../ui/controller/kampagnen-list/kampagnen-list';

export type KampagnenSortColumns = keyof typeof KampagnenSortierung;
export type KampagnenSorting = Sorting<KampagnenSortColumns>;

const defaultSorting: KampagnenSorting = [];

export const Aktionsaufgaben = () => {
  const [sorting, setSorting] = useQueryParamState<KampagnenSorting>(
    'sort',
    defaultSorting,
  );
  const [filterValues, setFilterValues] = useQueryParamState(
    'filter',
    {
      suchbegriff: '',
    },
  );

  const { data: kampagnen, loading: aufgabenLoading, pagination: aufgabenPagination, refetch: aufgabenRefetch } = useKampagnenSeitenweiseQuery(
    filterValues.suchbegriff,
    toSortierkriterium(sorting, KampagnenSortierung),
    toSortierrichtung(sorting, Sortierrichtung),
  );
  const [isRefetching, setIsRefetching] = useState(false);

  async function onPullToRefresh() {
    setIsRefetching(true);
    await aufgabenRefetch();
    setIsRefetching(false);
  }

  return (
    <MobilePage title="Aktionsaufgabe erstellen" onPullToRefresh={onPullToRefresh}>
      <div className="sticky top-0 z-50 bg-tds-color-organizer-90 pb-300">
        <div className="flex mb-2">
          <Link href="/objekte" className="flex items-center">
            <House size={22}></House>
          </Link>
        </div>
        <Filtering
          sorting={sorting}
          onSortChange={setSorting}
          sortOptions={[
            { 'label': 'Titel', 'value': 'AufgabenTitel' },
            { 'label': 'Fälligkeit', 'value': 'Faelligkeit' },
            { 'label': 'Name', 'value': 'Name' },
          ]}
          filterValues={filterValues}
          onFilterValuesChange={filterValues => {
            const newValues = { ...filterValues };
            newValues.suchbegriff = filterValues.suchbegriff || '';
            setFilterValues(newValues);
          }}
        />
      </div>

      <KampagnenListPagination kampagnen={kampagnen} pageLoading={aufgabenLoading && !isRefetching} pagination={aufgabenPagination} />
    </MobilePage>
  );
};
